
























































































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import InstanceFilter from '@/domain/contract/entity/instance-filter.entity';
import MainButton from '@/shared/buttons/main-button.component.vue';
import moment from 'moment';
import DateFormat from '@/shared/utils/date-format';
import statusTypes from './instance-status-types.json'
import Pagination from '../../../domain/pagination.entity';
import InstanceUtils from './instance-utils'
import InstanceStatusFactory from './InstanceStatusFactory';

@Component({ components: { MainButton, VbTooltipSlot } })
export default class InstanceFilterComponent extends Vue {
  @Prop({
    required: true,
    default: '',
  })
  private businessUnitId!: string;

  statusTypes: any[] = statusTypes;

  locale = 'pt-BR';

  filter: InstanceFilter = new InstanceFilter({});

  ref: any = this.$refs;

  withConsumpition: string = '';

  instanceStatus = InstanceUtils.InstanceStatus;

  instanceStatusType = InstanceUtils.InstanceStatusType;

  instanceStatusFactory: InstanceStatusFactory = new InstanceStatusFactory();

  status: string = '';

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 100,
    defaultSort: 'code|asc',
  })

  consumptionTypes = [
    {
      text: 'Com consumo',
      value: 'WITH_CONSUMPTION',
    },
    {
      text: 'Sem consumo',
      value: 'WITHOUT_CONSUMPTION',
    },
  ]

  clear() {
    this.ref.form.reset();
    this.filter = new InstanceFilter({});
  }

  send() {
    this.updateStatus();
    this.$emit('filter', this.filter);
  }

  created() {
    this.status = InstanceUtils.getInstanceUrlQueryParams(this.$route.query.status);
    this.withConsumpition = InstanceUtils.getInstanceUrlQueryParams(
      this.$route.query.withConsumption,
    );
    this.filter.competence = InstanceUtils.getInstanceUrlQueryParams(this.$route.query.competence);
  }

  get competenceDateText() {
    return DateFormat.fullMonthAndYear(DateFormat.localDateToLocal(this.filter.competence));
  }

  clearCompetence() {
    this.filter.competence = '';
  }

  clearStatus() {
    this.filter.status = '';
    this.filter.competence = '';
    this.withConsumpition = '';
    this.status = '';
  }

  updateStatus() {
    this.filter.status = this.instanceStatusFactory
      .getInstanceStatus(this.status, this.withConsumpition);
  }

  get getDefaultCompetence() {
    return moment().subtract(1, 'months').format('MM/YYYY');
  }

  get competenceMessage(): string {
    if (!this.withConsumpition) {
      return 'Informe o tipo';
    }
    return `Competência padrão: ${this.getDefaultCompetence}, caso não seja especificada`;
  }

  get statusTypeMessage(): string {
    if (!this.status) {
      return 'Informe o status'
    }
    return '';
  }
}
